(function(app) {

    app.provider("clientApi",
    [
        function() {
            this.$get = [
                "complianceHubApiGateway", function(complianceHubApiGateway) {
                    var service = {};

                    service.searchAgentClients = function (agentId, term) {
                        return complianceHubApiGateway.getArray("/Clients/Agents/" + agentId + "/Search?q=" + term).then(function (results) {
                            return results;
                        });
                    };                    

                    service.add = function (client) {
                        return complianceHubApiGateway.post("/Clients", client);
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app);